import styled from '@emotion/styled';

import { focusRingStyle } from '../../utils/sharedStyles';
export const MAIN_MENU_WRAPPER = 'main-menu-wrapper';
export const ICON_LINK_CLASS = 'icon-link';
export const JOIN_BTN_CLASS = 'join-btn';
export const MENU_OPTION_CLASS = 'mobile-menu-option';
export const BRAND_MENU_WRAPPER_CLASS = 'mobile-brand-menu';
export const SIGN_IN_BUTTONS_CLASS = 'sign-in-buttons';
export const SIGN_IN_WRAPPER_CLASS = 'sign-in-wrapper';
export const CLOSE_BTN_WRAPPER_CLASS = 'close-btn-wrapper';
export const USER_ITEM_CLASS = 'user-item-wrapper';
export const ICON_CLASS = 'nav-icon';
export const USER_GREETING_LINK_CLASS = 'user-greeting-class';
export const USER_GREETING_TEXT_CLASS = 'user-greeting-text-class';
export const PROFILE_IMAGE_CLASS = 'profile-image-class';
export const MOBILE_MENU_CLOSE_BTN = 'mobile-menu-close-btn';

export const PANEL_TEXT_CLASS = 'text-box-wrapper';
export const SLIDE_OUT_TITLE_CLASS = 'slide-out__title';
export const SLIDE_OUT_LINKS_CLASS = 'slide-out__links';
export const PANEL_CONTROL_CLASS = 'slide-out__controls';
export const PANEL_CONTENT_CLASS = 'slide-out__content';
export const SLIDE_OUT_CARET_CLASS = 'slide_out__previous_caret';

export const MOBILE_MENU_WIDTH = '320px';
export const SECTION_WIDTH = 286;
const HEADER_HEIGHT = '60px';
export const MENU_OPTION_HEIGHT = 48;

export const StyledPanelRow = styled.div`
  flex: 0 0 ${MOBILE_MENU_WIDTH};
  transition: transform var(--podium-cds-transition-duration-normal);
  transform: translateX(calc(${MOBILE_MENU_WIDTH} * -${props => props.slideLeftTimes}));

  .${MENU_OPTION_CLASS} {
    /*
      The menu option class here, is not subjected to the isLoggedIn property because it is inside
      a child menu where the account option is not visible since it is only displayed on the first
      page of the mobile menu.
    */
    padding: 8px 24px 8px 36px;
    ${focusRingStyle}
  }

  .${SLIDE_OUT_CARET_CLASS} {
    margin-left: -8px;
  }

  .${PANEL_TEXT_CLASS} {
    width: 204px;
  }
  a {
    color: var(--podium-cds-color-text-primary);
  }

  .${SLIDE_OUT_TITLE_CLASS} {
    min-height: 45px;
    padding: 8px 24px 8px 36px;
  }

  .${SLIDE_OUT_LINKS_CLASS} {
    padding: 12px 0px;
    padding-bottom: 150px;
  }

  .${PANEL_CONTROL_CLASS} {
    align-items: center;
    display: flex;
    height: ${MENU_OPTION_HEIGHT}px;
    justify-content: space-between;
    padding: 6px 18px 6px 24px;

    // Override Podiums default padding.
    .${MOBILE_MENU_CLOSE_BTN} {
      padding: 6px;
    }
  }

  .${PANEL_CONTENT_CLASS} {
    width: ${MOBILE_MENU_WIDTH};
    padding: 24px 0px;
  }
`;

export const onDomHidden = 'on-dom-hidden';
export const slideOut = 'slide-out';
export const SIGN_IN_BTN_CLASS = 'sign-in-btn';
export const StyledDiv = styled.div`
  background-color: var(--podium-cds-color-bg-primary);
  position: absolute;
  overflow-x: hidden;
  top: 0;
  height: 100vh;
  width: ${MOBILE_MENU_WIDTH};
  transition: transform var(--podium-cds-transition-duration-normal);
  z-index: 3;
  padding-top: 12px;
  display: none;

  .${BRAND_MENU_WRAPPER_CLASS} {
    padding: 24px 0px;
  }

  .${MENU_OPTION_CLASS} {
    align-items: center;
    display: flex;
    justify-content: space-between;
    min-height: 45px;
    width: 100%;
    padding: ${props => (props.isLoggedIn ? '6px 24px 6px 36px;' : '8px 24px 8px 36px;')};
  }

  .${ICON_CLASS} {
    margin-right: 12px;
  }

  .${ICON_LINK_CLASS} {
    color: var(--podium-cds-color-text-primary);
    align-items: center;
    display: flex;
    min-height: 40px;
    padding: 8px 24px 8px 30px;
    ${focusRingStyle}
  }

  .${JOIN_BTN_CLASS} {
    margin-right: var(--podium-cds-size-spacing-s);
    color: var(--podium-cds-color-text-primary-inverse);
    background-color: var(--podium-cds-button-color-bg-primary);
  }
  .${SIGN_IN_BTN_CLASS} {
    color: var(--podium-cds-color-text-primary);
    background-color: var(--podium-cds-button-color-bg-secondary);
    border: var(--podium-cds-button-color-border-secondary) 1px solid;
  }

  .${USER_ITEM_CLASS} {
    min-height: 248px;

    /** extra bottom padding is to fix an ios safari issue where the content is not viewable due to the bottom bar overlapping */
    padding: 24px 0 150px;
  }

  .${SIGN_IN_WRAPPER_CLASS} {
    padding: 48px 36px;
    a {
      ${focusRingStyle}
    }
  }

  .${SIGN_IN_BUTTONS_CLASS} {
    display: flex;
    margin-top: 24px;
    & > button {
      ${focusRingStyle}
    }
  }

  &.${onDomHidden} {
    right: 0;
    display: flex;
    visibility: visible;
    transform: translateX(${MOBILE_MENU_WIDTH});
    transition: transform var(--podium-cds-transition-duration-normal);
  }

  &.${slideOut} {
    transform: translateX(0px);
  }
  .${CLOSE_BTN_WRAPPER_CLASS} {
    display: flex;
    padding: 6px 18px 6px 24px;
    flex-wrap: wrap;
    flex-direction: column;
    align-content: end;

    // Override Podiums default padding.
    .${MOBILE_MENU_CLOSE_BTN} {
      padding: 6px;
    }
  }

  .pre-l-header.is-fixed .pre-mobilemenu {
    height: 'calc(100vh - %s)' % ${HEADER_HEIGHT};
  }

  .${USER_GREETING_LINK_CLASS} {
    // Overwrite the padding of MENU_OPTION_CLASS
    padding: 8px 24px 8px 30px;
  }

  .${USER_GREETING_TEXT_CLASS} {
    display: flex;
    align-items: center;
  }

  .${PROFILE_IMAGE_CLASS} {
    margin-right: 12px;
    border-radius: 24px;
    width: 36px;
    height: 36px;
  }

  .${MAIN_MENU_WRAPPER} {
    padding: 24px 0px;
  }

  @media screen and (prefers-reduced-motion: reduce), (update: slow) {
    // transition duration to force transitionEnd to be triggered when used has reduced motion accessibility activated.
    // dispatch transitionEnd is necessary to trigger menu toggle
    transition-duration: 0.01s !important;
  }
`;
